export default "__VITE_PUBLIC_ASSET__43a198e5__"